import { t } from 'src/i18n';

type NewItemLabel = { type: string; name: string };

/**
 * Etiketter for «Ny/Nytt <entitet>». Oversettelsene slås opp ved kall (ikke ved
 * modul-lasting) slik at i18next er initialisert før t() brukes.
 */
export function getNewItemLabels(): NewItemLabel[] {
  return [
    { type: 'functions', name: t('newItem.functions') },
    { type: 'documents', name: t('newItem.documents') },
    { type: 'guidelines', name: t('newItem.guidelines') },
    { type: 'contacts', name: t('newItem.contacts') },
    { type: 'contracts', name: t('newItem.contracts') },
    { type: 'reports', name: t('newItem.reports') },
    { type: 'riskAssessments', name: t('newItem.riskAssessments') },
    { type: 'issues', name: t('newItem.issues') },
    { type: 'events', name: t('newItem.events') },
    { type: 'tasks', name: t('newItem.tasks') },
    {
      type: 'constitutionalDocuments',
      name: t('newItem.constitutionalDocuments'),
    },
    { type: 'employees', name: t('newItem.employees') },
    { type: 'partners', name: t('newItem.partners') },
    { type: 'assets', name: t('newItem.assets') },
    { type: 'substances', name: t('newItem.substances') },
    { type: 'meetings', name: t('newItem.meetings') },
  ];
}

/**
 * Bakoverkompatibel array-tilgang. Bygges late via en Proxy slik at t() ikke
 * kalles ved modul-lasting (i18next må være initialisert først), men kallstedene
 * fortsatt kan bruke `newItemLabels.find(...)` direkte.
 */
export const newItemLabels: readonly NewItemLabel[] = new Proxy([] as NewItemLabel[], {
  get(_target, prop, receiver) {
    return Reflect.get(getNewItemLabels(), prop, receiver);
  },
});
